@if (evaluationData) {
<div class="w-full h-auto flex flex-col">
  <!-- Header da Avaliação -->
  <app-lesson-header
    icon="bi-clipboard-check"
    iconColor="text-blue-500"
    [title]="evaluationData.title"
    [subtitle]="evaluationData.subtitle"
    [module]="module"
    [showModuleInfo]="true"
    additionalClasses="mt-1 flex-shrink-0"
  >
  </app-lesson-header>

  <!-- Conteúdo da Avaliação -->
  <div
    class="flex-1 min-h-0 overflow-y-auto p-10 bg-gray-50 dark:bg-neutral-900"
  >
    <div class="w-full h-full flex flex-col">
      @if (currentQuestion) {
      <div class="content-card flex flex-1 flex-col p-6 pb-5">
        <!-- Cabeçalho da Questão -->
        <div class="mb-2 flex-1">
          <h4 class="text-lg font-semibold text-gray-900 dark:text-white mb-1">
            {{ currentQuestion.text }}
          </h4>
          @if (canSelectMultiple(currentQuestion.type)) {
          <p class="text-sm text-blue-500 mb-4">
            Você pode escolher 1 ou mais opções.
          </p>
          } @else if (currentQuestion.type === 'boolean') {
          <p class="text-sm text-blue-500 mb-4">
            Escolha uma opção: Verdadeiro ou Falso.
          </p>
          } @else {
          <p class="text-sm text-blue-500 mb-4">Escolha apenas uma opção.</p>
          }

          <!-- Opções de Resposta -->
          <div class="space-y-4">
            @for (option of currentQuestion.options; track option.id; let last =
            $last) {

            <button
              type="button"
              [class]="getOptionClass(currentQuestion.id, option.id)"
              [disabled]="isSubmitted()"
              (click)="toggleAnswer(currentQuestion.id, option.id)"
              class="flex w-full cursor-pointer items-center justify-between rounded border px-4 py-3 transition-all hover:shadow-sm disabled:cursor-not-allowed disabled:opacity-75"
            >
              <div class="flex items-center gap-3 flex-1 text-left">
                <span
                  class="font-medium text-gray-700 dark:text-neutral-300 min-w-[24px]"
                >
                  {{ option.label }})
                </span>
                <span class="text-sm text-gray-900 dark:text-white flex-1">
                  {{ option.text }}
                </span>
              </div>

              <!-- Checkmark -->
              @if (isSelected(currentQuestion.id, option.id)) {
              <i
                class="bi bi-check-circle-fill text-blue-500 text-xl flex-shrink-0"
              ></i>
              } @else {
              <i
                class="bi bi-circle text-gray-300 dark:text-neutral-600 text-xl flex-shrink-0"
              ></i>
              }
            </button>

            }
          </div>
        </div>

        <!-- Botão de Submissão (apenas na última lição do módulo 5) -->
        @if (isLastQuestion && isLastQuestionInModule5 && !isSubmitted()) {
        <div
          class="flex flex-col items-center pt-6 mt-6 border-t border-gray-200 dark:border-neutral-700 gap-4"
        >
          @if (showSuccessMessage()) {
          <div
            class="flex items-center gap-2 rounded border border-green-200 bg-green-50 px-4 py-2 text-green-700"
          >
            <i class="bi bi-check-circle-fill"></i>
            <span class="text-sm font-medium"
              >Respostas enviadas com sucesso! Redirecionando...</span
            >
          </div>
          } @else {
          <button
            type="button"
            [disabled]="!allQuestionsAnswered || isSubmitting()"
            (click)="submitAnswers()"
            class="btn-primary flex items-center gap-2 px-6 py-3"
          >
            @if (isSubmitting()) {
            <i class="bi bi-arrow-repeat animate-spin"></i>
            <span>Processando...</span>
            } @else {
            <span>Enviar Respostas</span>
            }
          </button>
          }
        </div>
        }
      </div>
      } @else {
      <div class="flex items-center justify-center h-full">
        <div class="text-center">
          <i
            class="bi bi-clipboard-check text-gray-400 dark:text-neutral-600 text-6xl mb-4"
          ></i>
          <p class="text-gray-500 dark:text-neutral-400">
            Nenhuma questão disponível
          </p>
        </div>
      </div>
      }
    </div>
  </div>
</div>
} @else {
<div
  class="w-full h-full flex items-center justify-center bg-gray-50 dark:bg-neutral-900"
>
  <div class="text-center">
    <i
      class="bi bi-clipboard-check text-gray-400 dark:text-neutral-600 text-6xl mb-4"
    ></i>
    <p class="text-gray-500 dark:text-neutral-400">Avaliação não disponível</p>
  </div>
</div>
}
